export const PROJECT_STATUSES_VALUES = {
  0: "Не рассчитан",
  1: "Черновик",
  2: "Рассчитано",
  3: "Ошибка",
  4: "Ограниченно рассчитан",
};

export const PROJECT_STATUSES = {
  0: "primary",
  1: "primary",
  2: "success",
  3: "danger",
  4: "warning",
};

export const DEFAULT_CREATE_PROJECT_FORM_DATA = {
  label: "",
  city: "",
  address: "",
  P0: 101.3,
  blockingUpClass: { code: "4", label: "Класс 4" },
};

export const USER_PAGE_MENU_ITEMS = [
  {
    text: "Основная информация",
    menuItem: "main-info",
  },
  {
    text: "Смена пароля",
    menuItem: "change-password",
  },
  {
    text: "Лицензии",
    menuItem: "license",
  },
  {
    text: "Оплата",
    menuItem: "pay",
  },
];

export const COUNTRIES = [
  { label: "Австралия", code: "au" },
  { label: "Австрия", code: "at" },
  { label: "Азербайджан", code: "az" },
  { label: "Албания", code: "al" },
  { label: "Алжир", code: "dz" },
  { label: "Ангола", code: "ao" },
  { label: "Андорра", code: "ad" },
  { label: "Антигуа и Барбуда", code: "ag" },
  { label: "Аргентина", code: "ar" },
  { label: "Армения", code: "am" },
  { label: "Афганистан", code: "af" },
  { label: "Багамы", code: "bs" },
  { label: "Бангладеш", code: "bd" },
  { label: "Барбадос", code: "bb" },
  { label: "Бахрейн", code: "bh" },
  { label: "Беларусь", code: "by" },
  { label: "Белиз", code: "bz" },
  { label: "Бельгия", code: "be" },
  { label: "Бенин", code: "bj" },
  { label: "Болгария", code: "bg" },
  { label: "Боливия", code: "bo" },
  { label: "Босния и Герцеговина", code: "ba" },
  { label: "Ботсвана", code: "bw" },
  { label: "Бразилия", code: "br" },
  { label: "Бруней", code: "bn" },
  { label: "Буркина-Фасо", code: "bf" },
  { label: "Бурунди", code: "bi" },
  { label: "Бутан", code: "bt" },
  { label: "Вануату", code: "vu" },
  { label: "Ватикан", code: "va" },
  { label: "Великобритания", code: "gb" },
  { label: "Венгрия", code: "hu" },
  { label: "Венесуэла", code: "ve" },
  { label: "Восточный Тимор", code: "tl" },
  { label: "Вьетнам", code: "vn" },
  { label: "Габон", code: "ga" },
  { label: "Гаити", code: "ht" },
  { label: "Гайана", code: "gy" },
  { label: "Гамбия", code: "gm" },
  { label: "Гана", code: "gh" },
  { label: "Гватемала", code: "gt" },
  { label: "Гвинея", code: "gn" },
  { label: "Гвинея-Бисау", code: "gw" },
  { label: "Германия", code: "de" },
  { label: "Гондурас", code: "hn" },
  { label: "Гренада", code: "gd" },
  { label: "Греция", code: "gr" },
  { label: "Грузия", code: "ge" },
  { label: "Дания", code: "dk" },
  { label: "Джибути", code: "dj" },
  { label: "Доминика", code: "dm" },
  { label: "Доминиканская Республика", code: "do" },
  { label: "Египет", code: "eg" },
  { label: "Замбия", code: "zm" },
  { label: "Зимбабве", code: "zw" },
  { label: "Израиль", code: "il" },
  { label: "Индия", code: "in" },
  { label: "Индонезия", code: "code" },
  { label: "Иордания", code: "jo" },
  { label: "Ирак", code: "iq" },
  { label: "Иран", code: "ir" },
  { label: "Ирландия", code: "ie" },
  { label: "Исландия", code: "is" },
  { label: "Испания", code: "es" },
  { label: "Италия", code: "it" },
  { label: "Йемен", code: "ye" },
  { label: "Кабо-Верде", code: "cv" },
  { label: "Казахстан", code: "kz" },
  { label: "Камбоджа", code: "kh" },
  { label: "Камерун", code: "cm" },
  { label: "Канада", code: "ca" },
  { label: "Катар", code: "qa" },
  { label: "Кения", code: "ke" },
  { label: "Кипр", code: "cy" },
  { label: "Киргизия", code: "kg" },
  { label: "Кирибати", code: "ki" },
  { label: "Китай", code: "cn" },
  { label: "Колумбия", code: "co" },
  { label: "Коморы", code: "km" },
  { label: "Конго (Браззавиль)", code: "cg" },
  { label: "Конго (Киншаса)", code: "cd" },
  { label: "Косово", code: "xk" },
  { label: "Коста-Рика", code: "cr" },
  { label: "Куба", code: "cu" },
  { label: "Кувейт", code: "kw" },
  { label: "Лаос", code: "la" },
  { label: "Латвия", code: "lv" },
  { label: "Лесото", code: "ls" },
  { label: "Либерия", code: "lr" },
  { label: "Ливан", code: "lb" },
  { label: "Ливия", code: "ly" },
  { label: "Литва", code: "lt" },
  { label: "Лихтенштейн", code: "li" },
  { label: "Люксембург", code: "lu" },
  { label: "Маврикий", code: "mu" },
  { label: "Мавритания", code: "mr" },
  { label: "Мадагаскар", code: "mg" },
  { label: "Малави", code: "mw" },
  { label: "Малайзия", code: "my" },
  { label: "Мали", code: "ml" },
  { label: "Мальдивы", code: "mv" },
  { label: "Мальта", code: "mt" },
  { label: "Марокко", code: "ma" },
  { label: "Маршалловы Острова", code: "mh" },
  { label: "Мексика", code: "mx" },
  { label: "Микронезия", code: "fm" },
  { label: "Мозамбик", code: "mz" },
  { label: "Молдова", code: "md" },
  { label: "Монако", code: "mc" },
  { label: "Монголия", code: "mn" },
  { label: "Мьянма (Бирма)", code: "mm" },
  { label: "Намибия", code: "na" },
  { label: "Науру", code: "nr" },
  { label: "Непал", code: "np" },
  { label: "Нигер", code: "ne" },
  { label: "Нигерия", code: "ng" },
  { label: "Нидерланды", code: "nl" },
  { label: "Никарагуа", code: "ni" },
  { label: "Новая Зеландия", code: "nz" },
  { label: "Норвегия", code: "no" },
  {
    label: "Объединенные Арабские Эмираты",
    code: "ae",
  },
  { label: "Оман", code: "om" },
  { label: "Пакистан", code: "pk" },
  { label: "Палау", code: "pw" },
  { label: "Панама", code: "pa" },
  { label: "Папуа — Новая Гвинея", code: "pg" },
  { label: "Парагвай", code: "py" },
  { label: "Перу", code: "pe" },
  { label: "Польша", code: "pl" },
  { label: "Португалия", code: "pt" },
  { label: "Россия", code: "ru" },
  { label: "Руанда", code: "rw" },
  { label: "Румыния", code: "ro" },
  { label: "Сальвадор", code: "sv" },
  { label: "Самоа", code: "ws" },
  { label: "Сан-Марино", code: "sm" },
  { label: "Сан-Томе и Принсипи", code: "st" },
  { label: "Саудовская Аравия", code: "sa" },
  { label: "Северная Корея", code: "kp" },
  { label: "Северная Македония", code: "mk" },
  { label: "Сейшелы", code: "sc" },
  { label: "Сенегал", code: "sn" },
  { label: "Сент-Винсент и Гренадины", code: "vc" },
  { label: "Сент-Китс и Невис", code: "kn" },
  { label: "Сент-Люсия", code: "lc" },
  { label: "Сербия", code: "rs" },
  { label: "Сингапур", code: "sg" },
  { label: "Сирия", code: "sy" },
  { label: "Словакия", code: "sk" },
  { label: "Словения", code: "si" },
  { label: "Соединенные Штаты", code: "us" },
  { label: "Соломоновы Острова", code: "sb" },
  { label: "Сомали", code: "so" },
  { label: "Судан", code: "sd" },
  { label: "Суринам", code: "sr" },
  { label: "Сьерра-Леоне", code: "sl" },
  { label: "Таджикистан", code: "tj" },
  { label: "Таиланд", code: "th" },
  { label: "Тайвань", code: "tw" },
  { label: "Танзания", code: "tz" },
  { label: "Того", code: "tg" },
  { label: "Тонга", code: "to" },
  { label: "Тринидад и Тобаго", code: "tt" },
  { label: "Тувалу", code: "tv" },
  { label: "Тунис", code: "tn" },
  { label: "Туркменистан", code: "tm" },
  { label: "Турция", code: "tr" },
  { label: "Уганда", code: "ug" },
  { label: "Узбекистан", code: "uz" },
  { label: "Украина", code: "ua" },
  { label: "Уругвай", code: "uy" },
  { label: "Фиджи", code: "fj" },
  { label: "Филиппины", code: "ph" },
  { label: "Финляндия", code: "fi" },
  { label: "Франция", code: "fr" },
  { label: "Хорватия", code: "hr" },
  {
    label: "Центральноафриканская Республика",
    code: "cf",
  },
  { label: "Чад", code: "td" },
  { label: "Черногория", code: "me" },
  { label: "Чехия", code: "cz" },
  { label: "Чили", code: "cl" },
  { label: "Швейцария", code: "ch" },
  { label: "Швеция", code: "se" },
  { label: "Шри-Ланка", code: "lk" },
  { label: "Эквадор", code: "ec" },
  { label: "Экваториальная Гвинея", code: "gq" },
  { label: "Эритрея", code: "er" },
  { label: "Эсватини", code: "sz" },
  { label: "Эстония", code: "ee" },
  { label: "Эфиопия", code: "et" },
  { label: "Южная Африка", code: "za" },
  { label: "Южная Корея", code: "kr" },
  { label: "Южный Судан", code: "ss" },
  { label: "Ямайка", code: "jm" },
  { label: "Япония", code: "jp" },
];

export const OBJECTS_BUTTONS = [
  {
    tabIndex: 0,
    title: "Установки",
  },
  {
    tabIndex: 1,
    title: "Трубопроводы",
  },
  {
    tabIndex: 2,
    title: "Обвалования",
  },
  {
    tabIndex: 3,
    title: "Персонал",
  },
  {
    tabIndex: 4,
    title: "Селитебные объекты",
  },
  {
    tabIndex: 5,
    title: "Противопожарные стены",
  },
  {
    tabIndex: 6,
    title: "Твердая горючая нагрузка",
  },
];

export const LVG_CODES = [1, 2, 3, 4, 5, 11, 14, 21, 31, 51];
export const SUG_CODES = [12, 15];
export const GAS_CODES = [13, 16];
export const SPILLAGE_COEFFICIENT = `<p align='left'>при отсутствии данных допускается принимать равным</p>
<p align='left'><b>5 м<sup>-1</sup></b> - при проливе на неспланированную грунтовую поверхность;</p>
<p align='left'><b>20 м<sup>-1</sup></b> - при проливе на спланированное грунтовое покрытие;</p>
<p align='left'><b>150 м<sup>-1</sup></b> - при проливе на бетонное или асфальтовое покрытие</p>`;

export const EXTINGUISH_OPTIONS = [
  { code: 0, label: "Отсутствует" },
  {
    code: 0.95,
    label:
      "Автоматическая установка пожаротушения или водяного орошения при наличии контроля за работоспособностью установки независимой организации (вне зависимости от типа установки пожаротушения)",
  },
  {
    code: 0.6,
    label:
      "Автоматическая установка водяного (пенного) пожаротушения или водяного орошения  при отсутствии контроля за работоспособностью установки независимой организацией",
  },
  {
    code: 0.5,
    label:
      "Остальные типы автоматических установок пожаротушения при отсутствии контроля за работоспособностью установки независимой организацией",
  },
];
